module.exports = __webpack_public_path__ + "static/photo6-6b807682b8e74e7dc0b0df186acb1a60.jpg";